module.exports = __webpack_public_path__ + "img/zhgd11.30446297.png";